import {stage} from "./stage.ts";

const config = {
    prd: {
        name: 'NEXT Cloud Login',
        host: 'https://login.nextcloud.aero',
        latestVersion: 15,
    },
    test: {
        name: 'NEXT Cloud Login',
        host: 'https://login-test.nextcloud.aero',
        latestVersion: 15,
    },
    dev: {
        name: 'NEXT Cloud Login',
        host: 'https://login-dev.nextcloud.aero',
        latestVersion: 15,
    },
    ide: {
        name: 'NEXT Cloud Login',
        host: process.env.VITE_HOST,
        latestVersion: 15,
    },
} as { [key: string]: any };

export default config[stage];
